const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    borderWidth: 1,
    p: 0.5,
    borderRadius: 0.5,
    width: '100%',
    flexDirection: { xs: 'column', md: 'row' },
    '&.column': {
      flexDirection: 'column!important',
    },
  },
  caption: {
    p: 0,
    ml: 1,
  },
  container: {
    justifyContent: 'space-between',
    alignItems: 'center',
    '&.MuiGrid-container': {
      padding: 0,
    },
  },

  iconsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  iconsContainerMap: {
    mixBlendMode: 'multiply',
  },

  ratingContainer: {
    padding: 0,
    '&.MuiGrid-container': {
      padding: 0,
    },
  },

  seeMore: {
    '&.MuiTypography-link-text': {
      ml: 0.5,
    },
  },

  disclaimerContainer: {
    padding: 1,
    backgroundColor: 'background.grey450',
  },
}

export default styles
